export default "__VITE_ASSET__XMvIQYMf__"